import { createFileRoute, useNavigate } from "@tanstack/react-router";
import useFlowBack from "@/hooks/@common/useFlowBack";
import GuestArtworkDetailPage from "@/pages/guestArtworkDetail/GuestArtworkDetailPage";
import NotFoundPage from "@/pages/notFound/NotFoundPage";

export const Route = createFileRoute(
  "/spaces/$spaceId/guest/artworks/$artworkId",
)({
  component: RouteComponent,
  notFoundComponent: NotFoundPage,
});

function RouteComponent() {
  const { spaceId, artworkId } = Route.useParams();
  const navigate = useNavigate();
  const flowBack = useFlowBack();

  return (
    <GuestArtworkDetailPage
      spaceId={spaceId}
      artworkId={Number(artworkId)}
      onBack={() =>
        flowBack({ to: "/spaces/$spaceId/guest", params: { spaceId } })
      }
      onWriteClick={() =>
        navigate({
          to: "/spaces/$spaceId/guest/guestbook/write",
          params: { spaceId },
        })
      }
    />
  );
}
